import React from 'react';
import { StyleProp, TextStyle, StyleSheet } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { normalize } from '@/hooks/use.screen.size';

export const ICONS = {
  back: 'chevron-back',
  search: 'search-outline',
  arrow_down: 'chevron-down-outline',
  arrow_up: 'chevron-up-outline',
  close: 'close',
  camera_disabled: 'videocam-off-outline',
  speaker_enabled: 'volume-high-outline',
  mute: 'mic-off',
  switch_camera: 'camera-reverse-outline',
  video_call: 'videocam-outline',
  voice_call: 'call-outline',
  check: 'checkmark-sharp',
  double_check: 'checkmark-done-sharp',
  fail: 'close-circle-outline',
  download: 'cloud-download-outline',
  upload: 'cloud-upload-outline',
  play: 'play-circle-outline',
  pause_play: 'pause-circle-outline',
  gallery: 'images-outline',
  camera: 'camera-outline',
  pdf: 'document-text-outline',
  location: 'location-sharp',
  add_new: 'add-circle-outline',
  mic: 'mic-circle-sharp',
  speaker: 'volume-medium',
  camera_fill: 'camera',
  warning: 'warning-outline',
  video: 'videocam-outline',
  person_add: 'person-add-outline',
  alarm: 'alarm-outline',
  time: 'time-outline',
  timer: 'timer-outline',
  info: 'information',
  drag_up: 'arrow-up-outline',
  drag_left: 'arrow-back-outline',
  send: 'send-outline',
  trash: 'trash-outline',
  edit: 'create-outline',
  copy: 'copy-outline',
  expand: 'expand-outline',
  refresh: 'refresh-outline',
  file: 'document-outline',
};

export interface IconButtonProps {
  size?: 'small' | 'medium' | 'big';
  rounded?: boolean;
  shadow?: boolean;
  icon: keyof typeof ICONS;
  color?: string;
  style?: StyleProp<TextStyle>;
  onPress?: (...args: any[]) => void;
}

function BaseIconButton({ size = 'medium', rounded = true, icon, color = 'white', shadow, style, ...rest }: IconButtonProps) {
  return (
    <Ionicons
      name={ICONS[icon] as any}
      color={color}
      size={size === 'small' ? 17 : size === 'medium' ? normalize(30) : normalize(40)}
      style={[shadow && styles.iconShadow, style]}
      {...rest}
    />
  );
}

const styles = StyleSheet.create({
  iconShadow: {
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 4,
  },
});

export const AppIconButton = React.memo(BaseIconButton);
